module.exports = __webpack_public_path__ + "static/img/login_bg.0d340d9.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/login_bg.jpg
// module id = npKG
// module chunks = 1